import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';

import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {MessageService} from 'primeng/api';
import {finalize} from 'rxjs';
import {Toast} from 'primeng/toast';
import {Router} from '@angular/router';
import {AuthService} from '@core/services/auth.service';
import {IconEntrarLogin} from '@components/icons/icon-entrar-login/icon-entrar-login.component';

@Component({
  selector: 'app-token-email',
  standalone: true,
  imports: [
    FormsModule,
    ButtonModule,
    CardModule,
    DialogModule,
    Toast,
    NgOptimizedImage,
    ReactiveFormsModule,
    IconEntrarLogin
],
  providers: [MessageService],
  templateUrl: './token-email.component.html',
  styleUrl: './token-email.component.css'
})
export class TokenEmailComponent implements OnInit {

  @Input() email: string = '';
  loading: boolean = false;
  tokenCtrl = new FormControl('', [Validators.required]);
  @Output() requestNewTokenEvent = new EventEmitter<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly messageService: MessageService,
    private readonly router: Router
  ) {
  }

  ngOnInit(): void {
    if (!this.email) {
      const storedEmail = sessionStorage.getItem('concessionariasEmail');
      if (storedEmail) {
        this.email = storedEmail;
      }
    }
    this.tokenCtrl.reset();
  }


  verifyToken() {
    if (this.tokenCtrl.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Token inválido',
        detail: 'Por favor, digite o token.'
      })
      return;
    }

    const token = this.tokenCtrl.value || '';

    this.authService
      .loginWithConcessionaria(this.email, token)
      .pipe(
        finalize(() => this.loading = false)
      ).subscribe({
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Token inválido',
          detail: 'O token inserido é inválido. Clique em “Enviar Token Novamente"',
        });
      }
    });
  }

  onRequestNewToken() {
    sessionStorage.removeItem('concessionariasEmailSent');
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['/auth/login-concessionarias']).then();
    });
  }


}
